module.exports = __webpack_public_path__ + "img/FrowningFace.8f4cc086.svg";